import { guidelines, stats } from "@/mocks/homeContent";
import SectionHeading from "./SectionHeading";

export default function TrustSection() {
  return (
    <section id="trust" className="w-full scroll-mt-20 bg-background-50 px-4 py-10 md:px-8 md:py-14">
      <SectionHeading
        eyebrow="投稿须知"
        title="先说清楚我们的规矩，再开始吃瓜"
        desc="黑料学生黑历史与实锤内容都建立在可核对与不伤人这两条底线上，下面是我们一直在执行的四条准则。"
      />

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
        {stats.map((item) => (
          <div
            key={item.label}
            className="rounded-lg border border-background-200/70 bg-background-100 px-4 py-5 text-center md:px-5 md:py-6"
          >
            <div className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
              {item.value}
            </div>
            <div className="mt-1.5 text-xs text-foreground-600 md:text-[13px]">{item.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-5 grid gap-4 md:grid-cols-2 md:gap-5 lg:grid-cols-4">
        {guidelines.map((item) => (
          <div
            key={item.title}
            className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className={`${item.icon} text-xl`}></i>
            </span>
            <h3 className="mt-3.5 text-sm font-semibold text-foreground-900">{item.title}</h3>
            <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-5 flex flex-col gap-4 rounded-lg border border-accent-300/60 bg-accent-50 p-4 md:flex-row md:items-center md:justify-between md:p-6">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
            <i className="ri-error-warning-line text-xl"></i>
          </span>
          <div>
            <h3 className="text-sm font-semibold text-foreground-900">
              被牵扯进话题里了？先别慌
            </h3>
            <p className="mt-1.5 max-w-2xl text-[13px] leading-relaxed text-foreground-700">
              如果发现自己在站内被误伤，可以提交澄清申请并附上能说明情况的材料。核对完成后，我们会更新状态标记，
              并在原内容旁附上澄清说明；涉及隐私的内容会直接下架。
            </p>
          </div>
        </div>
        <a
          href="#subscribe"
          className="inline-flex shrink-0 cursor-pointer items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-file-shield-2-line"></i>
          提交澄清申请
        </a>
      </div>
    </section>
  );
}